import React, { useEffect } from 'react'
import { Modal, Steps } from 'antd'
import { useTranslation } from 'react-i18next'

import { Button } from 'src/components/Ant'
import { useStepsContext } from 'src/views/Requests/views/Form/'
import history from 'src/config/routes/history'

import {
  ContainerSteps,
  WrapAlert,
  WrapSteps,
  WrapStepsIcon,
  WrapStepsIconCheck,
  WrapStepsTitle
} from './styles'

interface Props {
  onNext?(): void
}

function StepsNavigation({ onNext }: Props): JSX.Element {
  const { t } = useTranslation()
  const stepsContext = useStepsContext()

  useEffect(() => {
    function handleKeyup(e: KeyboardEvent) {
      if (e.altKey && e.ctrlKey && e.shiftKey) {
        if (e.key === 'ArrowLeft') {
          stepsContext.prev()
        } else if (e.key === 'ArrowRight') {
          handleNextStep()()
        }
      }
    }

    window.addEventListener('keyup', handleKeyup)

    return () => {
      window.removeEventListener('keyup', handleKeyup)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function handleNextStep() {
    return onNext || stepsContext.next
  }

  const isLastStep = stepsContext.current === stepsContext.steps.length - 1
  const currentAlert = stepsContext.steps[stepsContext.current].alert

  return (
    <>
      <ContainerSteps data-test-id="step-list">
        <Button
          data-test-id="step-previous"
          disabled={stepsContext.saving}
          onClick={
            stepsContext.current
              ? stepsContext.prev
              : () =>
                  Modal.confirm({
                    okText: t('common.actions.yes'),
                    cancelText: t('common.actions.no'),
                    content: t('web.setup.cancel-request.message'),
                    onCancel: () => {},
                    onOk: () => {
                      stepsContext.resetDraft()
                      history.push(`/my-requests`)
                    },
                    title: t('web.setup.cancel-request.title')
                  })
          }
          title={`common.actions.${
            stepsContext.current ? 'previous' : 'cancel'
          }`}
          type={stepsContext.current ? 'primary' : 'danger'}
        />
        <WrapSteps
          current={stepsContext.current}
          onChange={index => stepsContext.goTo(index)}
          size="small"
        >
          {stepsContext.steps.map(({ key, status, title }, index) => (
            <Steps.Step
              data-test-id={`step-item-${key}`}
              icon={
                index >= stepsContext.current ? (
                  <WrapStepsIcon status={status}>
                    {`${index + 1}`}
                  </WrapStepsIcon>
                ) : (
                  <WrapStepsIconCheck type="check-circle" />
                )
              }
              key={key}
              status={
                status.toString() as 'error' | 'finish' | 'process' | 'wait'
              }
              title={
                <WrapStepsTitle status={status}>{t(title)}</WrapStepsTitle>
              }
            />
          ))}
        </WrapSteps>
        <Button
          data-test-id="step-next"
          loading={stepsContext.saving}
          onClick={handleNextStep()}
          title={
            isLastStep ? 'web.new-request.steps.end' : 'common.actions.next'
          }
        />
      </ContainerSteps>
      {!!currentAlert && (
        <WrapAlert
          message={currentAlert.message}
          type={currentAlert.type}
          showIcon
        />
      )}
    </>
  )
}

export default StepsNavigation
